<div fxLayout="row" class="message-bar type-{{ type }}">
  <mat-icon>{{ icon }}</mat-icon>
  <div fxFlex="1 1 auto">
    <ng-content></ng-content>
  </div>
  <ng-content select=".actions"></ng-content>
</div>
